import { DocMetaData } from "./docMetaData";
import axiosInstance  from "./axiosSetup";
import { isBlank, parseDateUtility } from "./normalizeDocMetaData";


export const fetchInitialGridData = async (): Promise<DocMetaData[]> => {
    try {
        const response = await axiosInstance.get("/uploader/get_ingested_doc_list");
        const rawRows = response.data;
        console.log("ingestion response is", rawRows)

        return rawRows.map((row: any) => ({
            
            //Normalize fields
            fileName: row.fileName.split("/").slice(-1)[0] ?? `file_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`,
            fileDownloadUrl: `${encodeURIComponent(row.fileName)}`,
            entityType: isBlank(row.entityType) ? "" : row.entityType,
            entity: isBlank(row.entity) ? "" : row.entity,
            documentType: isBlank(row.documentType) ? "" : row.documentType,
            authorDate: parseDateUtility(row.authorDate),
            documentDate: isBlank(row.documentDate) ? "" : row.documentDate,

        }));

        // return await fetchMockPreLoadData();
    } catch (error) {
        console.log("Error fetching grid data:", error);
        throw new Error("Failed to fetch initial grid data");
    }
};